import type { ReactNode } from "react";
import { Inbox } from "lucide-react";
import { Button } from "@/shared/ui";

export interface EmptyStateProps {
  title: string;
  description: string;
  actionLabel?: string;
  onAction?: () => void;
  icon?: ReactNode;
}

/**
 * Gjendje bosh e riperdorshme per entitete klinike dhe administrative.
 */
export const EmptyState = ({ title, description, actionLabel, onAction, icon }: EmptyStateProps): JSX.Element => (
  <div className="flex min-h-56 flex-col items-center justify-center rounded-lg border border-dashed border-border bg-white/55 p-8 text-center">
    <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-secondary text-primary">
      {icon ?? <Inbox className="h-7 w-7" aria-hidden="true" />}
    </div>
    <h2 className="text-lg font-semibold text-foreground">{title}</h2>
    <p className="mt-2 max-w-md text-sm text-muted-foreground">{description}</p>
    {actionLabel ? (
      <Button className="mt-5" type="button" onClick={onAction}>
        {actionLabel}
      </Button>
    ) : null}
  </div>
);
